import React, { useEffect, useState } from 'react';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../../context/MyContext';

import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, ratecardList } from '../../../../config/config';
import { FcMoneyTransfer } from "react-icons/fc";
import { MdLocationCity, MdOutlineMap, MdApartment, MdPublic, MdTerrain, MdOutlinePayments } from "react-icons/md";
import { toast } from 'react-toastify';


const RateCard = () => {
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar,setIsToggleSidebar } = useMyContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [currentTab, setCurrentTab] = useState('surface');
  useEffect(() => {
    fetchRateCardList()
  }, [])

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };


  const fetchRateCardList = async () => {
    try {
      const url = Base_Url + ratecardList

      const response = await fetch(url + "/" + cus_id, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch data');
      }

      const result = await response.json();

      if (result && result.data) {
        setData(result.data);
      } else {
        console.error('Unexpected response structure:', result);
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error('Error fetching order data: ' + error.message);
    }
  };

  const accents = [
    { grad: 'from-gray-700 to-gray-500', soft: 'bg-gray-50 dark:bg-gray-800/50', text: 'text-gray-700 dark:text-gray-300' },
    { grad: 'from-gray-700 to-gray-500', soft: 'bg-gray-50 dark:bg-gray-800/50', text: 'text-gray-700 dark:text-gray-300' },
    { grad: 'from-gray-700 to-gray-500', soft: 'bg-gray-50 dark:bg-gray-800/50', text: 'text-gray-700 dark:text-gray-300' },
    { grad: 'from-gray-700 to-gray-500', soft: 'bg-gray-50 dark:bg-gray-800/50', text: 'text-gray-700 dark:text-gray-300' },
    { grad: 'from-gray-700 to-gray-500', soft: 'bg-gray-50 dark:bg-gray-800/50', text: 'text-gray-700 dark:text-gray-300' },
  ];

  const zoneIcons = {
    A: MdLocationCity,
    B: MdOutlineMap,
    C: MdApartment,
    D: MdPublic,
    E: MdTerrain,
  };
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

        <NavBar />
        <div className="flex flex-1 overflow-hidden">
           {isToggleSidebar && (
                   <div
                     className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                     onClick={() => setIsToggleSidebar(false)}
                   />
                 )}
       
                 <div
                   className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                 >
                   <Sidebar />
                 </div>
          <div className={`flex-1 min-h-0 flex flex-col bg-gray-200 dark:bg-darkmodeColor w-full p-3 md:p-4 overflow-hidden`}>

            {/* Header */}
            <div className="shrink-0 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
              <div className="flex items-center gap-2 min-w-0">
                <div className="relative shrink-0">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-800 dark:bg-gray-700 shadow-md">
                    <FcMoneyTransfer size={18} />
                  </div>
                </div>
                <div className="min-w-0">
                  <h1 className="text-sm md:text-base font-black text-gray-900 dark:text-white">
                    Rate Card
                  </h1>
                  <p className="text-[9px] text-gray-500 dark:text-gray-400">
                    Zone-wise shipping rates
                  </p>
                </div>
              </div>

              <button
                onClick={handleNavigation}
                className="shrink-0 text-[10px] font-semibold bg-gray-800 hover:bg-gray-700 text-white px-3 py-2.5 sm:py-1.5 rounded-lg transition-all w-full sm:w-auto"
              >
                ← Dashboard
              </button>
            </div>

            {/* Content - fills remaining space without scroll */}
            <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar">
              {data.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-center h-full bg-white dark:bg-darkmodeColor rounded-xl shadow-sm ring-1 ring-black/5 dark:ring-white/10">
                  <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-3">
                    <FcMoneyTransfer size={24} />
                  </div>
                  <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400">Loading your rate card</h3>
                  <p className="text-[10px] text-gray-400 dark:text-gray-500 mt-1">Rates will appear here once fetched.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 pb-1">
                  {Array.from(new Set(data.map(item => item.partner))).map((partner, index) => {
                    const zoneA = data.find(item => item.partner === partner && item.zone_name === 'A');
                    const zoneB = data.find(item => item.partner === partner && item.zone_name === 'B');
                    const zoneC = data.find(item => item.partner === partner && item.zone_name === 'C');
                    const zoneD = data.find(item => item.partner === partner && item.zone_name === 'D');
                    const zoneE = data.find(item => item.partner === partner && item.zone_name === 'E');

                    const zones = [
                      { key: 'A', label: 'Within City', data: zoneA },
                      { key: 'B', label: 'Within State', data: zoneB },
                      { key: 'C', label: 'Metro', data: zoneC },
                      { key: 'D', label: 'Rest of India', data: zoneD },
                      { key: 'E', label: 'J&K, NorthEast', data: zoneE },
                    ];

                    const accent = accents[index % accents.length];

                    return (
                      <div
                        key={partner}
                        className="bg-white dark:bg-darkmodeColor rounded-xl shadow-sm ring-1 ring-black/5 dark:ring-white/10 overflow-hidden"
                      >
                        {/* Partner header */}
                        <div className={`bg-gradient-to-r ${accent.grad} px-3 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2`}>
                          <h2 className="text-xs font-bold text-white capitalize">{partner}</h2>
                          <div className="flex items-center gap-1 bg-white/20 backdrop-blur-sm px-2 py-0.5 rounded-full w-fit">
                            <MdOutlinePayments className="w-3 h-3 text-white" />
                            <span className="text-[9px] font-semibold text-white">
                              COD {zoneA?.cod_percentage || '-'}% · Min ₹{zoneA?.min_cod_price || '-'}
                            </span>
                          </div>
                        </div>

                        {/* Zone grid */}
                        <div className="p-3 sm:p-2.5 grid grid-cols-2 gap-2 sm:gap-1.5">
                          {zones.map((zone) => {
                            const ZoneIcon = zoneIcons[zone.key];
                            return (
                              <div key={zone.key} className={`rounded-lg p-2.5 sm:p-2 ${accent.soft}`}>
                                <div className="flex items-center gap-1 mb-1">
                                  <ZoneIcon className={`w-3 h-3 ${accent.text} flex-shrink-0`} />
                                  <span className="text-[8px] font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400 truncate">
                                    {zone.label}
                                  </span>
                                </div>
                                <div className="flex items-baseline gap-1.5 mb-0.5">
                                  <span className={`text-[13px] sm:text-xs font-bold ${accent.text}`}>₹{zone.data?.express_price || '-'}</span>
                                  <span className="text-[8px] text-gray-400 dark:text-gray-500">Express</span>
                                </div>
                                <div className="flex items-baseline gap-1.5 mb-1">
                                  <span className="text-[13px] sm:text-xs font-semibold text-gray-700 dark:text-gray-200">₹{zone.data?.surface_price || '-'}</span>
                                  <span className="text-[8px] text-gray-400 dark:text-gray-500">Surface</span>
                                </div>
                                <div className="text-[8px] text-gray-500 dark:text-gray-400 leading-relaxed">
                                  +₹{zone.data?.additional_expressprice_per500gm || '-'}/500g
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RateCard;